import { create } from 'zustand';

export type ToastType = '' | 'success' | 'error';

export interface ToastItem {
	id: number;
	msg: string;
	type: ToastType;
}

interface ToastStore {
	toasts: ToastItem[];
}

let seq = 0;

export const useToastStore = create<ToastStore>(() => ({ toasts: [] }));

export function showToast(msg: string, type: ToastType = '') {
	const id = ++seq;
	useToastStore.setState((s) => ({ toasts: [...s.toasts, { id, msg, type }] }));
	setTimeout(() => {
		useToastStore.setState((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
	}, 3200);
}
